import React from "react";
import { LeagueViewTab } from "./MobileLeagues";
import { Search, PersonOutlined } from "@mui/icons-material";
import "./LeagueStyles.scss";

interface MobileLeaguePanelProps {
  currentView: LeagueViewTab;
  setCurrentView: React.Dispatch<React.SetStateAction<LeagueViewTab>>;
  paddingTop?: boolean;
}

const MobileLeaguePanel: React.FC<MobileLeaguePanelProps> = ({
  setCurrentView,
  currentView,
  paddingTop,
}) => {
  return (
    <div className={`leagueTabs${paddingTop ? " leagueTabs--pad" : ""}`}>
      <button
        type="button"
        className={`leagueTabs__tab${
          currentView === "Search" ? " leagueTabs__tab--active" : ""
        }`}
        onClick={() => setCurrentView("Search")}
      >
        <Search className="leagueTabs__icon" />
        Search
      </button>
      <button
        type="button"
        className={`leagueTabs__tab${
          currentView === "YourLeagues" ? " leagueTabs__tab--active" : ""
        }`}
        onClick={() => setCurrentView("YourLeagues")}
      >
        <PersonOutlined className="leagueTabs__icon" />
        My Leagues
      </button>
    </div>
  );
};

export default MobileLeaguePanel;
